import AppCreator from '@/agilis/components/AppCreator/AppCreator.vue'
import ComponentResolver from '@/agilis/components/ComponentResolver/ComponentResolver.vue'
import ComponentResolverMobile from '@/agilis/mobile/ComponentResolverMobile/ComponentResolverMobile.vue'
import VueDraggable from 'vue-draggable'
import axios from './plugins/axios'
import i18n from './i18n/i18n'
import router from './router'
import store from './store'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { initVuetify } from '@/plugins/vuetify'
import formValidation from './plugins/formValidation' // eslint-disable-line no-unused-vars
import uiComponents from './plugins/uiComponents' // eslint-disable-line no-unused-vars

import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'
import './registerServiceWorker'
import { setKeycloak } from '@/plugins/keycloak'

Vue.component('ComponentResolver', ComponentResolver)
Vue.component('ComponentResolverMobile', ComponentResolverMobile)

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(VueDraggable)

useApplicationPlugins()

// Register a global custom directive called `v-blur` that prevents focus
Vue.directive('blur', {
  inserted: function (el) {
    el.onfocus = (ev) => ev.target.blur()
  }
})

// https://vuedose.tips/tips/debugging-templates-in-vue-js/
Vue.prototype.$debug = function () {
  console.log('$debug ' + JSON.stringify(arguments)) //eslint-disable-line
}

// check if the app is in mobile mode
Vue.prototype.$isMobile = function () {
  try {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.userAgentData.mobile
  } catch {
    return false
  }
}

// environment is externalized so we can inject via kubernetes configmaps
Vue.prototype.$envmap = window.envmap
const vueInstanceOptions = {
  router,
  store,
  i18n,
  axios,
  render: h => h(AppCreator)
}
if (window.envmap.VUE_APP_AGILIS_KEYCLOAK_REQUIRED) {
  Vue.use(VueKeycloakJs, {
    init: {
      // Use 'login-required' to always require authentication
      onLoad: 'check-sso'
    },
    config: {
      url: window.envmap.VUE_APP_AGILIS_KEYCLOAK_ENDPOINT,
      clientId: window.envmap.VUE_APP_AGILIS_KEYCLOAK_CLIENT_ID,
      realm: window.envmap.VUE_APP_AGILIS_KEYCLOAK_REALM
    },
    onReady: keycloak => {
      setKeycloak(keycloak)
      vueInstanceOptions.keycloak = keycloak
      const vuetify = initVuetify()
      createVueInstance(vuetify)
    }
  })
} else {
  handleConfigurationLoadFailure()
}

function handleConfigurationLoadFailure () {
  const vuetify = initVuetify()
  createVueInstance(vuetify)
}

function createVueInstance (vuetify) {
  vueInstanceOptions.vuetify = vuetify
  new Vue(vueInstanceOptions).$mount('#app')
}

function useApplicationPlugins () {
  const requireContext = require.context('./applications', true, /plugins\/.*\.js$/)
  requireContext.keys().forEach(pluginPath => {
    const plugin = requireContext(pluginPath)
    if (plugin.default && typeof plugin.default.install === 'function') {
      Vue.use(plugin.default)
    }
  })
}
